import { Dialog } from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onClose: () => void;
}

const ROWS: { keys: string[]; description: string }[] = [
  { keys: ["Ctrl", "K"], description: "Open command palette (jump-to-page)" },
  { keys: ["⌘", "K"], description: "Same on macOS" },
  { keys: ["R"], description: "Refresh status" },
  { keys: ["?"], description: "Show this help" },
  { keys: ["Esc"], description: "Close any modal" },
];

export function ShortcutHelp({ open, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Keyboard shortcuts"
      description="Pressed anywhere except inside a text field."
      size="md"
    >
      <ul className="space-y-2">
        {ROWS.map((r, i) => (
          <li key={i} className="flex items-center justify-between gap-3 text-sm">
            <div className="flex items-center gap-1">
              {r.keys.map((k, ki) => (
                <kbd
                  key={ki}
                  className="px-1.5 py-0.5 rounded bg-bg border border-border font-mono text-xs"
                >
                  {k}
                </kbd>
              ))}
            </div>
            <span className="text-muted">{r.description}</span>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
